import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as $ from 'jquery';
import { orderEdit, orderLoad } from '../../../redux/actions/order/orderActions';
import { examLoad, examUpdate } from '../../../redux/actions/exam/examActions';
import { patientReportsLoad } from '../../../itrust_common/redux/actions/settingActions/patientReportActions';
import { tabChange } from '../../../itrust_common/redux/actions/otherActions';
import { currentStoreLoad, storeStaffsLoad } from '../../../redux/actions/currentStoreActions';
import { procedurePricingsLoad } from '../../../redux/actions/storeSettings/ProcedurePricingActions';
import { handleStopExamRecording } from '../exam/CommonFunctions';
import { storeSettingLoad } from '../../../redux/actions/storeSettings/storeSettingActions';

export const openOrderForEdit = async (dispatch, { orderId, storeId, isTelemedExam, isClaimFormAvailable, isOpenByPatientStatment }) => {
  let localStorageStoreId = localStorage.getItem('StoreID')
  const idToLoad = localStorageStoreId || storeId;
  dispatch(storeSettingLoad({ filter: { store_id: idToLoad || '' }, page: 1, rpp: 999999999, sort: 'position', direction: 'asc' }))
  if (!localStorageStoreId) {
    dispatch(currentStoreLoad())
    dispatch(procedurePricingsLoad({ rpp: 99999, filter: { for_store: storeId }, include: ['procedures'] }))
  }
  if ((localStorageStoreId && localStorageStoreId !== 'null') || storeId) {
    dispatch(storeStaffsLoad(localStorageStoreId || storeId, { rpp: 1000, filter: { doctor: localStorageStoreId } }))
  }

  dispatch(orderEdit(orderId));
  dispatch(tabChange(isClaimFormAvailable ? { order: 6 } : isOpenByPatientStatment ? { order: 5 } : { order: 1 }))
  let res = await dispatch(orderLoad(orderId, { direction: "desc", sort: "created_at", include: '*' }))
  res = res.value.data.order
  if (res.exam_examination_id) {
    dispatch(examLoad(res.exam_examination_id, { include: '*' })).then(async (examRes) => {
      if (isTelemedExam) {
        const recordingRes = await handleStopExamRecording()
        recordingRes && dispatch(examUpdate({ id: examRes.value.data.exam.id, telemed_visits_attributes: [recordingRes] }, { include: '*' }))
      }
    })
  }
  dispatch(patientReportsLoad({ patient_id: res.patient_attributes.id, staff_id: res.staff_id, store_id: res.store_attributes.id, filter: { category: "invoice" } }))
  setTimeout(function () {
    $('#editExamForm-modal').modal('hide');
    $('#orderForm-modal').modal('show');
  }, 1000)
}

export default function EditOrderButton(props) {
  const { orderId, storeId, children, isTelemedExam, isClaimFormAvailable, isOpenByPatientStatment } = props;

  const dispatch = useDispatch()
  const history = useHistory()

  const handleOrderEdit = () => {
    openOrderForEdit(dispatch, { orderId, storeId, isTelemedExam, isClaimFormAvailable, isOpenByPatientStatment })
    const match = window.location.pathname.match(/^(\/order\/(all-orders|recent-orders|unfinished-orders|finalized-orders))/);
    if (match) {
      history.push(`${match[1]}/${orderId}`)
    }
  }

  return (
    <span
      className="pointer"
      onClick={handleOrderEdit}
    >
      {children}
    </span>
  )
}
